(function () {
  function addBizDays(d, n) {
    var r = new Date(d);
    while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0) n--; }
    return r;
  }
  function fmt(d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); }

  function delivery() {
    document.querySelectorAll('[data-swx-deliv]:not([data-done])').forEach(function (el) {
      el.setAttribute('data-done', '1');
      var min = parseInt(el.dataset.min, 10) || 2, max = parseInt(el.dataset.max, 10) || 5, cut = parseInt(el.dataset.cutoff, 10) || 16;
      var now = new Date();
      var ist = new Date(now.getTime() + (now.getTimezoneOffset() + 330) * 60000);
      var shipToday = ist.getHours() < cut && ist.getDay() !== 0;
      var ship = shipToday ? ist : addBizDays(ist, 1);
      var eta = el.querySelector('[data-swx-eta]');
      if (eta) eta.textContent = fmt(addBizDays(ship, min)) + ' – ' + fmt(addBizDays(ship, max));
      var c = el.querySelector('[data-swx-cut]');
      if (!c) return;
      if (shipToday) {
        var tick = function () {
          var n = new Date(); var i = new Date(n.getTime() + (n.getTimezoneOffset() + 330) * 60000);
          var left = (cut * 60) - (i.getHours() * 60 + i.getMinutes());
          if (left <= 0) { c.textContent = 'Ships next business day · tracked delivery'; return; }
          c.innerHTML = 'Order within <b>' + Math.floor(left / 60) + 'h ' + (left % 60) + 'm</b> for same-day dispatch';
        };
        tick(); setInterval(tick, 30000);
      } else {
        c.textContent = 'Dispatched within 48 hours · tracked delivery';
      }
    });
  }

  function sticky() {
    var bar = document.querySelector('[data-swx-sticky]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var sid = bar.dataset.section;
    var btn = bar.querySelector('[data-swx-sticky-btn]');
    var priceEl = bar.querySelector('[data-swx-sticky-price]');
    var getSubmit = function () { return document.getElementById('ProductSubmitButton-' + sid); };
    var buyArea = document.querySelector('#MainProduct-' + sid + ' product-form') || getSubmit();

    btn.addEventListener('click', function () {
      var s = getSubmit();
      if (s && !s.disabled) s.click();
      else if (buyArea) buyArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    function syncPrice() {
      var box = document.getElementById('price-' + sid);
      if (!box) return;
      var p = box.querySelector('.price__sale:not([hidden]) .price-item--sale, .price--on-sale .price-item--sale') || box.querySelector('.price-item--regular');
      if (p && priceEl) priceEl.textContent = p.textContent.trim();
      var s = getSubmit();
      if (s) {
        btn.disabled = s.disabled;
        btn.textContent = s.disabled ? (s.textContent.trim() || 'Sold out') : 'Add to cart';
      }
    }
    var host = document.getElementById('MainProduct-' + sid);
    if (host) new MutationObserver(function () { clearTimeout(syncPrice.t); syncPrice.t = setTimeout(syncPrice, 60); }).observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    syncPrice();

    if (buyArea && 'IntersectionObserver' in window) {
      var past = false, atFoot = false;
      var apply = function () {
        var on = past && !atFoot;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      };
      new IntersectionObserver(function (es) {
        var e = es[0];
        past = !e.isIntersecting && e.boundingClientRect.top < 0;
        apply();
      }).observe(buyArea);
      var foot = document.querySelector('.sxf, .shopify-section-group-footer-group');
      if (foot) new IntersectionObserver(function (es) { atFoot = es[0].isIntersecting; apply(); }).observe(foot);
    }
  }

  function init() { delivery(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
